import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams, json } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import { SetGame } from './store.js';
import { NotiReq } from './fcm.js';
import { TimerLeft, TimerAgo } from './timer.js';
import { ImageLoader, ImgSlot } from './imgloader.js';
import { Static, SaveToast, ShowToast, ShowLoading, ImgGet, ImgGetHas, ModalEditPf, ModalCopyGame, ModalMsgInput, GetAvatar, GetUserBadge } from './util.js';
import { GaugeChart, GetMatchCol } from './gauge.js';
import { Adsense } from './ads.js';
import { AppDownloadModal } from './popup.js';

import { useSpring, animated, easings } from '@react-spring/web'
import toast, { Toaster } from 'react-hot-toast';
import TextareaAutosize from 'react-textarea-autosize';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import Offcanvas from 'react-bootstrap/Offcanvas';

import ImgNullPf from './img/NullPf.jpg';
import ImgNoImg from './img/NoImg.png';

import ImgCrown from './img/Crown.png';
import ImgCrown1 from './img/Crown1.png';
import ImgCrown2 from './img/Crown2.png';
import ImgCrown3 from './img/Crown3.png';
import ImgLogo from './img/Logo.png';
import ImgTitle from './img/Title_Black.png';
import Admin from './Admin.js';




function Game() {

    const store = useSelector((state) => state);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { addImgKey, loadImgs } = ImageLoader();

    let { uid } = useParams();

    const uuid = localStorage.getItem('uuid');

    let [uidErr, uidErrSet] = useState(false);

    let [loading, loadingSet] = useState(true);
    let [game, gameSet] = useState();
    let [ans, ansSet] = useState([]);

    let [join, joinSet] = useState(false);

    let [ans0, ans0Set] = useState([]);
    let [ans1, ans1Set] = useState([]);
    let [ans2, ans2Set] = useState([]);
    let [user, userSet] = useState();
    let [msg, msgSet] = useState({});

    let [rank, rankSet] = useState([]);
    let [me, meSet] = useState();
    let [top, topSet] = useState();
    let [pt, ptSet] = useState({});

    let [imgqz, imgqzSet] = useState({});
    let [imgPf, imgPfSet] = useState({});
    let [nick, nickSet] = useState(localStorage.getItem('nick'));
    let [sex, sexSet] = useState(localStorage.getItem('gender') == null ? 'n' : localStorage.getItem('gender'));
    let [sexm, sexmSet] = useState(0);
    let [sexf, sexfSet] = useState(0);
    let [cpFail, cpFailSet] = useState(false);

    let [done, doneSet] = useState(false);
    let [closed, closedSet] = useState(false);
    let [mygame, mygameSet] = useState(false);
    let [noti, notiSet] = useState(false);

    let [result, resultSet] = useState(false);

    let [showFimg, showFimgSet] = useState(false);
    let [fimg, fimgSet] = useState(false);

    const msgIdx = useRef(0);
    let [msgModal, msgModalSet] = useState();
    const uidDelMsg = useRef(0);
    let [msgopModal, msgopModalSet] = useState();

    let [opModal, opModalSet] = useState();
    let [copyModal, copyModalSet] = useState();
    let [pfModal, pfModalSet] = useState();
    let pfModalClose = () => pfModalSet(false);
    let [editPfState, editPfStateSet] = useState(false);
    //let editPfState = false;

    let [copyTitle, copyTitleSet] = useState('');
    let [showAppDownloadModal, showAppDownloadModalSet] = useState(false);
    let [copyDesc, copyDescSet] = useState('');
    const stateTxt = useRef();
    const stateCol = useRef();

    const [aniResTxt, aniResTxtApi] = useSpring(() => ({
        from: {
            opacity: 0,
            y: 0
        },
    }))
    const [aniResTxt2, aniResTxt2Api] = useSpring(() => ({
        from: {
            opacity: 0,
            y: 0
        },
    }))

    const [aniCntPer, aniCntPerApi] = useSpring(() => ({
        from: { count: 0 },
    }));



    useEffect(() => {

        let user = 'null'

        if (uuid !== null) {
            user = uuid;
        }

        axios.post(Static.SvrAddr + 'game', {
            game: uid,
            user: user
        }).then((res) => {
            console.log(res);

            if (res.data[0].length == 0) {
                console.log('게임없음');
                uidErrSet(true);
                return;
            }
            let gd = res.data[0][0];
            gameSet(gd);


            gd.op = JSON.parse(gd.op);
            gd.qz = JSON.parse(gd.qz);

            dispatch(SetGame(gd));

            copyTitleSet(gd.title);
            copyDescSet(gd.sub);

            let ad = [];
            let adMy = [];
            let ud = {};

            let sm = 0;
            let sf = 0;
            res.data[1].map((d, i) => {
                console.log(d.User_uid);

                let ans = JSON.parse(d.ans);
                d.ans = ans;

                ud[d.User_uid] = { uid: d.User_uid, nick: d.nick, sex: d.sex, ans: ans };


                if (d.User_uid == uuid) {
                    ad.unshift(d);

                    adMy.push(d);
                }
                else {
                    ad.push(d);
                }

                // ImgGetHas(Static.SvrAddr, 'pf/' + d.User_uid).then(res => {
                //     console.log(res);
                //     imgPfSet(old => ({ ...old, [d.User_uid]: res }))
                // });
                addImgKey('pf/' + d.User_uid);

                if (d.sex == 'm') sm++;
                if (d.sex == 'f') sf++;
            });

            ansSet(ad);
            sexmSet(sm);
            sexfSet(sf);

            let join = false;
            res.data[1].map((d, i) => {
                if (d.User_uid == user) {
                    join = true;
                    joinSet(join);
                }
            })
            // let join = true;
            // joinSet(true);  

            mygameSet(gd.User_uid == uuid);



            let close = gd.closed == 1;
            closedSet(close);
            let done = ad.length >= gd.player || close;
            doneSet(done);

            let cpFail = false;
            if (gd.op.cp) {
                if (sm < 1 || sf < 1) {
                    cpFail = true;
                    cpFailSet(cpFail);
                }
            }



            ShowToast();

            let ans0 = ad;

            let result = done && join && (ad.length > 1 || close) && !cpFail;
            resultSet(result);

            if (!result) {
                ans0 = adMy;
            }

            ans0Set(ans0);

            ans1Set([]);
            ans2Set([]);


            let md = {};
            gd.qz.map((d, i) => {
                md[i] = [];
            })
            res.data[2].map((d, i) => {
                if (result) {
                    md[d.idx].push(d);
                }
                else {
                    if (d.User_uid == uuid) {
                        md[d.idx].push(d);
                    }
                }
            })
            msgSet(md);
            console.log(md);

            //meuid = "60d875ed-216f-11ee-a24d-0a83ced4ff06";
            meSet(ud[uuid]);



            userSet(ud);
            console.log(ud);


            LoadQzImg(uid, gd.qz)

            let per = 0;

            let all = {};
            for (var key in ud) {

                let res = GetRankData(gd.qz, ans0, gd, ud, key);
                console.log(res);
                res.map((d, i) => {
                    if (i == 0) {
                        per = Number(d[0]);
                    }

                    if (!all.hasOwnProperty(d[0])) {
                        all[d[0]] = [];
                    }

                    d[1].map((rd, i) => {
                        all[d[0]].push([key, rd.uid]);
                    })
                })

                if (key == uuid) {
                    rankSet(res);
                }
            }
            console.log(all);


            all = Object.entries(all).sort((a, b) => b[0] - a[0]);
            console.log(all);

            let top = {}
            all.map((d, i) => {
                let grp = {};

                d[1].map((nd, i) => {
                    let ary = nd.sort();
                    let key = ary.join('');
                    grp[key] = nd;
                })

                let grpary = [];
                for (var key in grp) {
                    grpary.push(grp[key]);
                }
                top[d[0]] = grpary;
            })

            console.log(top);
            let ts = Object.entries(top).sort((a, b) => b[0] - a[0]);
            console.log(ts);
            ts.splice(3);

            ts.map((d, i) => {
                d[1].map((sd, si) => {
                    let list = sd;
                    if (sd[0] == uuid || sd[1] == uuid) {
                        d[1].splice(si, 1);
                        d[1].splice(0, 0, list);
                    }

                    let uid = sd[1];
                    if (uid == uuid) {
                        sd.splice(1, 1);
                        sd.splice(0, 0, uid);
                    }
                })
            })

            topSet(ts);


            if (done) {
                if (join) {
                    stateTxt.current = '결과가 발표 되었어요!';
                    stateCol.current = 'bg-success';
                } else {
                    stateTxt.current = '게임에 참여하지 않아 결과를 볼 수 없어요.';
                    stateCol.current = 'bg-secondary';
                }
            } else {
                if (join) {
                    stateTxt.current = '모든 친구가 참여하거나 게임이 마감되면 결과를 볼 수 있어요.';
                    stateCol.current = 'bg-secondary';
                } else {
                    stateTxt.current = '밸런스게임으로 친구와 궁합을 보세요.';
                    stateCol.current = 'bg-secondary';
                }
            }


            setTimeout(() => {
                aniResTxtApi.start({
                    from: {
                        opacity: 0,
                        y: 0
                    },
                    to: {
                        opacity: 1,
                        y: 10
                    },
                    config: { duration: 1000 },
                })
            }, 300);

            setTimeout(() => {
                aniResTxt2Api.start({
                    from: {
                        opacity: 0,
                        y: 0
                    },
                    to: {
                        opacity: 1,
                        y: 10
                    },
                    config: { duration: 1000 },
                })

                aniCntPerApi.start({
                    count: per,
                    config: { duration: 1000 },
                })
            }, 900);



            setTimeout(() => {
                loadingSet(false);
            }, 100);



        }).catch(() => {
            console.log('실패함');
        })

    }, [])



    function LoadQzImg(uid, qz) {

        qz.map((d, i) => {

            if (d[3] == 'N' && d[4] == 'N') {
                // imgqzSet(old => ({ ...old, [i + 'A']: null }))
                // imgqzSet(old => ({ ...old, [i + 'B']: null }))
            }
            else {
                if (d[3] != 'N') {
                    let key = d[3] == '@' ? Static.ImgType.qz + uid + '_' + i + '-A' : Static.ImgType.lib + d[3] + '-A';

                    addImgKey(key);

                    imgqzSet(old => ({ ...old, [i + 'A']: key }))
                }
                else {
                    // imgqzSet(old => ({ ...old, [i + 'A']: ImgNoImg }))
                }

                if (d[4] != 'N') {
                    let key = d[4] == '@' ? Static.ImgType.qz + uid + '_' + i + '-B' : Static.ImgType.lib + d[4] + '-B';

                    addImgKey(key);

                    imgqzSet(old => ({ ...old, [i + 'B']: key }))
                }
                else {
                    // imgqzSet(old => ({ ...old, [i + 'B']: ImgNoImg }))
                }
            }
        })

        loadImgs();
    }


    function GetRankData(qd, ad, gd, user, meuid) {
        let point = {};

        qd.map((d, i) => {

            let grpA = [];
            let grpB = [];
            ad.map((da, ai) => {
                let a = da.ans[i];
                if (a == 1) {
                    grpA.push(da.User_uid);
                }
                if (a == 2) {
                    grpB.push(da.User_uid);
                }
            })
            ans1Set(old => [...old, grpA]);
            ans2Set(old => [...old, grpB]);

            for (var key in user) {
                if (key != meuid) {
                    if (!point.hasOwnProperty(key)) {
                        point[key] = 0;
                    }
                    if (grpA.includes(key) && grpA.includes(meuid) || grpB.includes(key) && grpB.includes(meuid)) {
                        point[key] += 1;
                    }
                }
            }
        })
        //gd.op.cp =false;
        if (gd.op.cp) {
            for (let key in point) {
                if (user[meuid].sex == user[key].sex) {
                    delete point[key];
                }
            }
        }


        let rnk = {};
        for (var key in point) {
            if (key != meuid) {
                let per = (point[key] / qd.length * 100).toFixed(0);
                let val = { uid: key, nick: user[key].nick, sex: user[key].sex };
                if (rnk.hasOwnProperty(per)) {
                    rnk[per].push(val);
                }
                else {
                    rnk[per] = [val];
                }

                pt[per] = point[key];
            }
        }

        const res = Object.entries(rnk);
        res.sort((a, b) => b[0] - a[0]);
        //const rnks = Object.fromEntries(entries);

        return res;
    }



    function ClickPlay() {
        if (game.op.cp) {
            if (nick == null || sex == 'n') {
                OpenPfModal(false);
            }
            else {
                CpPlayCheck();
            }
        }
        else {
            nick == null ? OpenPfModal(false) : StartGame()
        }
    }

    function CpPlayCheck() {
        let remain = game.player - ans.length;

        let gen = localStorage.getItem('gender');

        if (gen == 'm') {
            if (sexm >= 2 && sexf < 2) {
                if (remain <= 2 - sexf) {
                    alert("남자는 더 이상 참여 할 수 없어요.");
                    return;
                }
            }
        }

        if (gen == 'f') {
            if (sexf >= 2 && sexm < 2) {
                if (remain <= 2 - sexm) {
                    alert("여자는 더 이상 참여 할 수 없어요.");
                    return;
                }
            }
        }

        StartGame();
    }

    function OpenPfModal(edit) {
        editPfStateSet(edit);

        pfModalSet(true);
    }

    function StartGame() {
        navigate('/game/' + uid + '/play')
    }



    function CloseGame() {

        if (ans.length < 2) {
            window.confirm('참여 인원이 부족해 지금은 결과를 불 수 없어요.')
            return;
        }

        if (game.op.cp) {
            if (sexm < 1 || sexf < 1) {
                window.confirm('참여 성비 인원이 부족해 지금은 결과를 불 수 없어요.')
                return;
            }
        }

        if (window.confirm('더 이상 다른 친구들이 이 게임에 참여할 수 없어요. 게임을 마감할까요?')) {
            axios.post(Static.SvrAddr + 'closegame', {
                game: uid,
            }).then((res) => {
                window.location.reload();
            }).catch(() => {
                console.log('실패함');
            })
        }
    }

    function DelGame() {
        if (window.confirm('더 이상 게임 참가 및 결과를 볼 수 없어요. 삭제할까요?')) {

            axios.post(Static.SvrAddr + 'delgame', {
                game: uid,
            }).then((res) => {

                SaveToast('[' + game.title + '] 게임을 삭제했어요.');

                let keys = [];
                game.qz.map((d, i) => {
                    if (d[3] == '@') keys.push('qz/' + uid + '_' + i + '-A');
                    if (d[4] == '@') keys.push('qz/' + uid + '_' + i + '-B');
                })

                if (keys.length > 0) {
                    axios.post(Static.SvrAddr + 'dels3', {
                        keys: keys,
                    }).then((res) => {
                        console.log(res);
                    }).catch(() => {
                        console.log('실패함');
                    })
                }

                navigate('/mypage');

            }).catch(() => {
                console.log('실패함');
            })
        }
    }

    function ClickMsg(uid, user) {
        if (user == uuid) {
            uidDelMsg.current = uid;
            console.log(uid);
            msgopModalSet(true);
        }
    }
    function DelMsg() {
        msgopModalSet(false);

        axios.post(Static.SvrAddr + 'delmsg', {
            uid: uidDelMsg.current,
        }).then((res) => {

            SaveToast('댓글을 삭제했어요.');

            window.location.reload();

        }).catch(() => {
            console.log('실패함');
        })
    }

    function GetPFImgClass(sex) {

        if (sex == 'm') return 'rounded-circle mx-1 border border-2 border-info';
        if (sex == 'f') return 'rounded-circle mx-1 border border-2 border-danger';
        return 'rounded-circle mx-1';
    }

    function GetSexBadge(type, val) {
        if (game.op.cp) {
            if (type == 'm') return (<span class="text-info ms-2"><i class="fi-rr-mars"></i>{val}</span>);
            if (type == 'f') return (<span class="text-danger ms-2"><i class="fi-rr-venus"></i>{val}</span>);
        }
        return '';
    }





    function GetSlotCol(a) {

        const hexToRgb = (hex) => {
            // '#ef532f'에서 '#' 제거
            const cleanedHex = hex.replace('#', '');

            // 각 색상 채널 값 추출
            const r = parseInt(cleanedHex.substring(0, 2), 16);
            const g = parseInt(cleanedHex.substring(2, 4), 16);
            const b = parseInt(cleanedHex.substring(4, 6), 16);

            return { r, g, b };
        };

        a = Math.max(0, Math.min(1, a));

        const startColor = { r: 211, g: 211, b: 211 }; // lightgrey
        const endColor = hexToRgb('#00A652');

        const r = Math.round(startColor.r + a * (endColor.r - startColor.r));
        const g = Math.round(startColor.g + a * (endColor.g - startColor.g));
        const b = Math.round(startColor.b + a * (endColor.b - startColor.b));

        return `rgb(${r}, ${g}, ${b})`;
    }


    function ResultSlot(type) {
        const rnk0 = type === 0;
        const grp = type > 0;
        let rnk = 0;

        let imgCrown = ImgCrown1;

        if (type === 2) { imgCrown = ImgCrown2; rnk = 1; }
        if (type === 3) { imgCrown = ImgCrown3; rnk = 2; }

        return (
            <div className="" style={{ width: '100%' }}>
                {grp && <img src={imgCrown} alt="Crown" className="" style={{ width: '80px' }} />}

                <div className="border rounded-5 border-light bg-light">
                    <div className="rounded-5 bg-white m-1 ">
                        <div className="p-2">
                            <GaugeChart qz={game.qz.length} match={pt[top[rnk][0]]} type={type} />
                        </div>
                    </div>

                    {grp && (
                        <div className="my-3">
                            {top[rnk][1].map((d, i) => (
                                <div key={i} className="d-flex w-100 justify-content-center align-items-start px-2 my-3 gap-2">
                                    {TopRankUserSlot(d[0], rnk)}
                                    {/* {GetIcon('x', rnk0 ? 60 : 30)} */}
                                    <div className="align-self-center">
                                        <i class="fi-rr-cross va-m fs-6 text-black-50"></i>
                                    </div>
                                    {TopRankUserSlot(d[1], rnk)}
                                </div>
                            ))}
                        </div>
                    )}

                </div>

            </div>
        );
    }

    function TopRankUserSlot(uid, rnk) {
        const me = user[uid].uid === uuid;
        let col = '';
        if (game.op.cp) {
            col = user[uid].sex === 'm' ? 'text-info' : 'text-info';
        }

        const avatarSize = rnk === 0 ? 80 : 50;
        const fontSize = rnk === 0 ? 'fs-6' : 'fs-7';
        const fontWeight = me ? 'fw-bold' : '';

        const img = store.img[Static.ImgType.pf + user[uid].uid];

        return (
            <div className="w-100">
                <div className="d-flex flex-column align-items-center justify-content-start">
                    {GetAvatar(img, user[uid].nick, avatarSize)}
                    <span className={fontSize + ' ' + col + ' ' + fontWeight}>{user[uid].nick}</span>
                </div>
            </div>
        );
    }


    function TopRankSlot(uid, idx) {
        const img = store.img[Static.ImgType.pf + user[uid].uid];

        return (
            <>
                <div className='justify-content-center col'>
                    <img className={GetPFImgClass(user[uid].sex)}
                        src={img}
                        style={{
                            objectFit: 'cover',
                            width: idx == 0 ? '100px' : '50px',
                            height: idx == 0 ? '100px' : '50px',
                        }}
                    />
                    <div className={idx == 0 ? 'fs-2' : 'fs-6'}>
                        {user[uid].uid == uuid ? (
                            <span className='fw-bold'>{user[uid].nick}</span>) : (<>{user[uid].nick}</>
                        )}
                    </div>
                </div>
            </>
        )
    }

    function ShowFullImg(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <img
                    src={store.img[fimg]}
                    onClick={() => { showFimgSet(false) }}
                    style={{
                        cursor: 'pointer',
                        objectFit: 'cover',
                        width: '100%'
                    }}
                />
            </Modal>
        );
    }

    function UserSlot(idx) {
        // console.log('UUUU  =====  ' + ans[idx].User_uid);
        // const img = store.img[Static.ImgType.pf + ans[idx].User_uid];

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                {ans.length > idx ? (
                    <>
                        {GetAvatar(store.img[Static.ImgType.pf + ans[idx].User_uid], ans[idx].nick, 80)}
                        <span style={{ fontSize: '16px', fontWeight: ans[idx].User_uid == uuid ? 'bold' : 'normal' }}>
                            {ans[idx].nick}
                        </span>
                    </>
                ) : (
                    <>
                        {GetAvatar('null', '', 80)}
                        <span className='text-secondary' style={{ fontSize: '16px' }}>
                            나
                        </span>
                    </>
                )}
            </div>
        )

    }


    function QzSlot(key, txt, imgslot, col) {
        const img = imgqz[key];

        return (
            <div className='d-flex flex-column col-6 rounded rounded-4' style={{
                border: `4px solid ${col}`,
            }}>
                {img == null ? (
                    <div className="d-flex align-items-center flex-fill justify-content-center fs-5 p-2">
                        {txt}
                    </div>
                ) : (
                    <>
                        <ImgSlot
                            imgKey={img}
                            className='rounded rounded-4'
                            style={{
                                objectFit: 'cover',
                                height: '100px',
                                width: '100%'
                            }}
                            onClick={() => { fimgSet(img); showFimgSet(true); }}
                        />
                        <div className='p-2'>
                            {txt}
                        </div>
                    </>
                )}
            </div>
        )
    }


    function AnsSlot(idx, qty, ans, col) {
        const per = ((qty / ans0.length) * 100).toFixed(0);

        return (
            <div className='rounded rounded-4 bg-light' style={{
                flex: 1,
                padding: '10px',
                marginBottom: '10px',
            }}>
                {result && (
                    <div className='position-relative justify-content-center' style={{
                        height: '15px',
                        marginBottom: '10px',
                    }}>
                        <div className='d-flex flex-column bg-secondary-subtle' style={{
                            alignItems: ans === 1 ? 'flex-end' : 'flex-start',
                            borderRadius: '10px',
                            height: '15px',
                            width: '100%',
                        }}>
                            <div className='' style={{
                                flexDirection: 'row-reverse',
                                backgroundColor: col,
                                borderRadius: '10px',
                                height: '15px',
                                width: `${per}%`,
                            }}></div>
                        </div>
                        <div className='position-absolute top-0 start-50  translate-middle-x ' style={{
                            fontSize: 10
                        }}>{per}%</div>
                    </div>
                )}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                }}>
                    {ans0.map((da, ia) => (
                        da.ans[idx] === ans && (
                            <div key={ia} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {GetUserBadge(store.img[Static.ImgType.pf + da.User_uid], da, 25, da.User_uid == uuid, game.op.cp, false)}
                            </div>
                        )
                    ))}
                </div>
            </div>
        );
    }





    if (uidErr) {
        return (
            <div>
                <div>
                    이미 삭제된 게임이거나 잘못된 주소에요.
                </div>
                <div>
                    <Button className='border-0 m-2 p-2' onClick={() => { navigate('/') }}> 새로운 게임 해 보기 </Button>
                </div>
            </div>
        )
    }

    if (loading) {
        return ShowLoading()
    }

    return (
        <div className=''>


            {mygame && !done && (
                <>
                    <div className='alert alert-primary align-items-center' role="alert">
                        <Alert.Heading className='text-start'>친구를 초대하세요.</Alert.Heading>
                        <div className='text-start pb-1'>
                            참여를 원하는 친구에게 링크를 공유하세요.
                        </div>
                        <div className='d-flex justify-content-end'>
                            <button className='btn btn-secondary me-2' onClick={() => {
                                navigator.clipboard.writeText(window.location.href);
                                toast.success('링크가 복사 되었어요.');
                            }}>
                                <i class="fi-sr-share pe-2 va-m"></i>링크복사
                            </button>

                            <button className='btn btn-outline-secondary' onClick={() => { opModalSet(true) }}>
                                <i class="fi-sr-settings va-m"></i>
                            </button>
                        </div>
                    </div>
                </>)
            }


            {/* <div className='text-secondary fs-7'>
                <b>{game.maker}</b>님이 만든 밸런스 게임
            </div> */}

            <div className='p-4 '>


                <div className='fs-1'>
                    <b>{game.title}</b>
                </div>

                <div className='text-secondary fs-6'>
                    {game.sub}
                </div>
                <div className='p-1 fs-7 text-secondary'>
                    <span className='px-3'>
                        {game.op.cp && '이성끼리 궁합 보기'}
                    </span>
                </div>


                <div className={'justify-content-center align-items-center my-5 rounded-5 ' + stateCol.current}>
                    <div className='p-3 text-white fs-6'>{stateTxt.current}</div>
                    {game.player == 2 && (
                        <div className='d-flex justify-content-center align-items-center py-3 rounded-5 bg-light'>

                            <div className='justify-content-center align-items-center flex-column'>
                                {UserSlot(1)}
                            </div>
                            <div className='mx-4 justify-content-center align-items-center' style={{ color: 'rgba(0, 0, 0, 0.2)' }}>
                                <i class="fi-rr-cross va-m fs-1"></i>
                            </div>
                            <div className='justify-content-center align-items-center flex-column'>
                                {UserSlot(0)}
                            </div>

                        </div>
                    )}


                    {game.player > 2 && (


                        <div className='bg-light rounded-5 p-3' >
                            <div style={{ display: 'flex', flexDirection: 'row', padding: '0 5px' }}>
                                <span className='text-start' style={{ flexGrow: 1, fontSize: 16 }}>참가자  {ans.length}/{game.player}</span>
                                {game.op.cp && (
                                    <span className='border-secondary-subtle' style={{ fontSize: 16, paddingRight: 10 }}>
                                        {GetSexBadge('m', sexm)}{GetSexBadge('f', sexf)}
                                    </span>
                                )}
                            </div>

                            {ans.length > 0 && (
                                <>
                                    <div className='flex-fill'>
                                        <hr></hr>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        {ans.map((d, i) => (
                                            GetUserBadge(store.img[Static.ImgType.pf + d.User_uid], d, 25, d.User_uid == uuid, game.op.cp, game.User_uid == d.User_uid)
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>

                    )}
                </div>




                {!done && (
                    <>
                        {join ? (
                            <>
                                <div class="alert alert-success fs-4 fw-bold p-1" role="alert">
                                    <i class="fi-rr-check-circle va-m"></i> 게임 완료
                                </div>

                            </>
                        ) : (
                            <div className='d-flex flex-column gap-2'>
                                {nick == null ? (
                                    <>밸런스 게임으로 보는 궁합</>
                                ) : (
                                    <Button variant="outline-secondary" className='d-flex flex-fill btn-lg rounded-pill align-items-center justify-content-between p-3 px-5' onClick={() => {
                                        OpenPfModal(true)
                                    }}>
                                        <span className='fs-5'>닉네임</span>

                                        <span className='text-secondary fs-6'>{nick} {GetSexBadge(sex)} <i class="fi-sr-pencil va-m ps-2 fs-4"></i></span>

                                    </Button>
                                )}


                                <Button className='d-flex flex-fill btn-lg rounded-pill text-white align-items-center justify-content-between p-3 px-5' onClick={() => {
                                    ClickPlay();
                                }}>
                                    <span className='fs-5'>게임 시작</span>
                                    <span className='fs-6'>{game.qz.length}문제<i className="fi-sr-play va-m ps-2 fs-4"></i></span>
                                </Button>
                            </div>
                        )}




                        <ModalEditPf show={pfModal} handleClose={pfModalClose} playmod={true} sexmod={game.op.cp} cpmod={game.op.cp} cb={(e) => {
                            nickSet(e);
                            sexSet(localStorage.getItem('gender'));
                            if (!editPfState) {
                                game.op.cp ? CpPlayCheck() : StartGame();
                            }
                        }} />
                    </>
                )}

            </div>


            {/* <div className='m-5'>
                <button className='btn btn-outline-secondary' onClick={() => { navigate('/result/' + uid) }}> 결과 보기 </button>
                <button className='btn btn-outline-secondary' onClick={() => { ClickPlay() }}> 플레이 </button>
            </div> */}




            {result && (
                <>

                    {game.player == 2 ? (
                        <>
                            {ResultSlot(0)}

                            {/* <div className='fs-5'>
                                우리의 궁합은?
                            </div>

                            <animated.div style={{ ...aniResTxt }}>
                                <div className='fs-1 mb-3'>
                                    <b>{GetMacthMsg(rank[0][0]).res}</b>
                                </div>
                            </animated.div>

                            <animated.div style={{ ...aniResTxt2 }}>
                                <div>
                                    <div className='px-0 fs-6'>
                                        매칭률
                                    </div>

                                    <div className='fs-2 badge text-bg-dark rounded-5 mb-3'>
                                        <animated.span>
                                            {aniCntPer.count.to(x => x.toFixed(0))}
                                        </animated.span>%
                                    </div>
                                </div>
                            </animated.div>


                            <div className=''>
                                <img src={GetMacthMsg(rank[0][0]).img} style={{ height: '200px' }} />
                            </div>

                            <div className='fs-3 alert alert-primary rounded-pill mx-5'>
                                {GetMacthMsg(rank[0][0]).msg}
                            </div> */}

                        </>
                    ) : (
                        <>
                            <div className='my-5'>
                                <div className='fs-5 text-black-50'>
                                    <b>{me.nick}</b> 님과 가장 잘 맞는 친구는
                                </div>
                                <div className='d-flex justify-content-center fs-1 gap-3'>
                                    {
                                        rank[0][1].map((d, i) => {
                                            return (
                                                <b>
                                                    {d.nick}
                                                    <div className='bg-success' style={{ height: '10px', }}>
                                                    </div>
                                                </b>

                                            )
                                        })
                                    }
                                </div>
                                <div className='fs-5 text-black-50 my-3'>
                                    님 이에요!
                                </div>
                            </div>


                            <div className='pt-5 fs-2'>
                                나와의 매칭률
                            </div>


                            <div className='bg-light' style={{ display: 'flex', flexDirection: 'column', padding: '20px', borderRadius: '20px' }}>
                                {rank.map((item, idx) => (
                                    <div key={idx} style={{ flex: 1, marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                                            <div className='' style={{ flex: 1, textAlign: 'center' }}>
                                                {idx === 0 && <img src={ImgCrown} alt="Crown" style={{ height: '40px', width: '40px' }} />}
                                                <div style={{ fontWeight: 'bold' }}>{idx + 1}위</div>
                                            </div>
                                            <div style={{ flex: 3, display: 'flex', flexDirection: 'row' }}>
                                                <div>
                                                    {item[1].map((d, i) =>
                                                        GetUserBadge(store.img[Static.ImgType.pf + d.uid], d, 30, false, game.op.cp, false)
                                                    )}
                                                </div>
                                            </div>
                                            <div style={{ flex: 1, textAlign: 'right', alignItems: 'center', paddingRight: '15px' }}>
                                                <div style={{ fontWeight: 'bold', fontSize: '18px', color: GetMatchCol(game.qz.length, pt[item[0]]) }}>
                                                    {item[0]}%
                                                </div>
                                            </div>
                                        </div>
                                        <div className='bg-secondary-subtle' style={{ height: '5px', borderRadius: '45px', position: 'relative' }}>
                                            <div style={{ position: 'absolute', height: '5px', width: `${item[0]}%`, borderRadius: '45px', backgroundColor: GetMatchCol(game.qz.length, pt[item[0]]) }}></div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </>
                    )}




                    {game.player > 2 && (
                        <>
                            <div className='my-1'>
                                <Adsense type={'dp'} />
                            </div>

                            <div className='pt-5 fs-2'>
                                매칭 랭킹
                            </div>

                            {ResultSlot(1)}

                            {/* <div className='border rounded-5 border-dark-subtle'>
                                <img src={ImgCrown1} style={{ height: '100px' }} />
                                <div className='fs-3'>
                                    <b>{GetMacthMsg(top[0][0]).res}</b>
                                </div>
                                <div className='fs-4 badge text-bg-secondary rounded-5'>
                                    {top[0][0]}%
                                </div>
                                <div className=''>
                                    <img src={GetMacthMsg(top[0][0]).img} style={{ height: '200px' }} />
                                </div>
                                <div className='fs-3 alert alert-primary rounded-pill mx-5'>
                                    {GetMacthMsg(top[0][0]).msg}
                                </div>
                                <div className='p-3'>
                                    <hr></hr>
                                </div>
                                <div>
                                    {top[0][1].map((td, ti) => {
                                        return (
                                            <>
                                                <div className='d-flex justify-content-center my-5'>
                                                    {TopRankSlot(td[0], 0)}
                                                    <div className='pt-4'>
                                                        <i class="fi-rr-cross va-m fs-1 text-black-50"></i>
                                                    </div>
                                                    {TopRankSlot(td[1], 0)}
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </div> */}

                            <div className='my-1'>
                                <Adsense type={'dp'} />
                            </div>

                            <div className='d-flex justify-content-center my-3 gap-2'>
                                {top.length >= 2 && ResultSlot(2)
                                    // (
                                    //     <div className='col-6 border rounded-4 flex-fill p-2 m-2'>
                                    //         <div className='justify-content-center align-items-center'>
                                    //             <img src={ImgCrown2} style={{ height: '60px' }} />
                                    //             <div className='fs-4'>
                                    //                 {GetMacthMsg(top[1][0]).res}
                                    //             </div>
                                    //             <div className='fs-5 badge text-bg-secondary rounded-5'>
                                    //                 {top[1][0]}%
                                    //             </div>
                                    //             <div className=''>
                                    //                 <img src={GetMacthMsg(top[1][0]).img} style={{ height: '100px' }} />
                                    //             </div>
                                    //             <div className='fs-6 alert alert-primary rounded-pill'>
                                    //                 {GetMacthMsg(top[1][0]).msg}
                                    //             </div>
                                    //         </div>
                                    //         <div className='p-2'>
                                    //             <hr></hr>
                                    //         </div>
                                    //         <div className='justify-content-center align-items-center'>
                                    //             {top[1][1].map((td, ti) => {
                                    //                 return (
                                    //                     <div className='d-flex justify-content-center py-2'>
                                    //                         {TopRankSlot(td[0], 1)}
                                    //                         <div className='pt-3'>
                                    //                             <i class="fi-rr-cross va-m fs-6 text-black-50"></i>
                                    //                         </div>
                                    //                         {TopRankSlot(td[1], 1)}
                                    //                     </div>
                                    //                 )
                                    //             })}
                                    //         </div>
                                    //     </div>
                                    // )
                                }

                                {top.length >= 3 && ResultSlot(3)
                                    // (
                                    //     <div className='col-6 border rounded-4 flex-fill p-2 m-2'>
                                    //         <img src={ImgCrown3} style={{ height: '60px' }} />
                                    //         <div className='fs-4'>
                                    //             {GetMacthMsg(top[2][0]).res}
                                    //         </div>
                                    //         <div className='fs-5 badge text-bg-secondary rounded-5'>
                                    //             {top[2][0]}%
                                    //         </div>
                                    //         <div className=''>
                                    //             <img src={GetMacthMsg(top[2][0]).img} style={{ height: '100px' }} />
                                    //         </div>
                                    //         <div className='fs-6 alert alert-primary rounded-pill'>
                                    //             {GetMacthMsg(top[2][0]).msg}
                                    //         </div>
                                    //         <div className='p-2'>
                                    //             <hr></hr>
                                    //         </div>
                                    //         <div className='justify-content-center align-items-center'>
                                    //             {top[2][1].map((td, ti) => {
                                    //                 return (
                                    //                     <div className='d-flex justify-content-center py-2'>
                                    //                         {TopRankSlot(td[0], 1)}
                                    //                         <div className='pt-3'>
                                    //                             <i class="fi-rr-cross va-m fs-6 text-black-50"></i>
                                    //                         </div>
                                    //                         {TopRankSlot(td[1], 1)}
                                    //                     </div>
                                    //                 )
                                    //             })}
                                    //         </div>
                                    //     </div>
                                    // )
                                }


                            </div>
                        </>

                    )}

                </>
            )
            }


            <div className='my-4'>
                <Adsense type={'ia'} />
            </div>


            {(result || (!done && join)) && (
                <div className='mt-5'>
                    {(!done && join) ? (
                        <div className='mb-5'>
                            <div className='fs-3'>
                                친구의 참여를 기다리는 동안
                            </div>
                            <div className='fs-6'>
                                선택한 이유를 댓글로 달아보세요.
                            </div>
                            <i class="fs-1 text-black-50 fi-rr-arrow-alt-circle-down va-m"></i>
                        </div>
                    ) : (
                        <div className='fs-2'>
                            선택 결과
                        </div>
                    )}



                    {
                        game.qz.map((d, i) => {
                            const col1 = GetSlotCol(ans1[i].length / ans0.length);
                            const col2 = GetSlotCol(ans2[i].length / ans0.length);
                            return (
                                <div className='mb-5'>
                                    {(i > 0) && (i % 3 == 0) && (
                                        <div className=''>
                                            <Adsense type={'dp'} />
                                        </div>
                                    )}

                                    <div className='d-flex'>
                                        <div className='flex-fill'>
                                            <hr></hr>
                                        </div>
                                        <div className='mx-4'>
                                            <h3>{i + 1}</h3>
                                        </div>
                                        <div className='flex-fill'>
                                            <hr></hr>
                                        </div>
                                    </div>


                                    <div className='d-flex flex-column p-2'>
                                        <div className='my-3'>
                                            {game.qz[i][0]}
                                        </div>
                                        <div className='d-flex gap-1'>
                                            {QzSlot(i + 'A', game.qz[i][1], null, col1)}
                                            {QzSlot(i + 'B', game.qz[i][2], null, col2)}

                                            {/* <div className={'d-flex flex-column col-6 rounded-top border ' + GetBorder(ans2[i].length, ans1[i].length)}>

                                                {imgqz[i + 'B'] == null ? (
                                                    <div class="d-flex align-items-center flex-fill justify-content-center fs-5 p-2">
                                                        {game.qz[i][2]}
                                                    </div>
                                                ) : (
                                                    <>
                                                        <img className='rounded-top' src={imgqz[i + 'B']}
                                                            onClick={() => { fimgSet(imgqz[i + 'B']); showFimgSet(true); }}
                                                            style={{
                                                                objectFit: 'cover',
                                                                height: '100px',
                                                                width: '100%'
                                                            }}></img>
                                                        <div className='p-2'>
                                                            {game.qz[i][2]}
                                                        </div>
                                                    </>
                                                )}


                                            </div> */}
                                        </div>

                                        <div className='d-flex gap-1'>
                                            {AnsSlot(i, ans1[i].length, 1, col1)}
                                            {AnsSlot(i, ans2[i].length, 2, col2)}
                                        </div>
                                    </div>

                                    {msg[i].map((md, mi) => {
                                        return (
                                            <div className={'d-flex my-2 mx-3 ' + (user[md.User_uid].ans[i] == 1 ? ('text-start') : ('justify-content-end flex-row-reverse text-end'))}>
                                                <div className={GetPFImgClass(user[md.User_uid].sex)}>
                                                    {GetAvatar(store.img[Static.ImgType.pf + md.User_uid], user[md.User_uid].nick, 45)}
                                                </div>

                                                <div className='d-flex flex-column '>

                                                    <div className={user[md.User_uid].ans[i] == 1 ? ('') : ('d-flex flex-row-reverse align-items-end')}>
                                                        {md.User_uid == uuid ? (
                                                            <span className='fw-bold'>{user[md.User_uid].nick}</span>) : (<>{user[md.User_uid].nick}</>
                                                        )}
                                                        <span className='text-secondary mx-2 fs-7'>
                                                            {TimerAgo(new Date(md.insdt).getTime())}
                                                        </span>
                                                    </div>

                                                    <div className={user[md.User_uid].ans[i] == 1 ? ('d-flex') : ('d-flex flex-row-reverse')}>
                                                        <div className={'p-3 rounded-5 rounded-top-0 ' + (user[md.User_uid].ans[i] == 1 ? ('rounded-end-5') : ('rounded-start-5'))}
                                                            style={{ backgroundColor: GetSlotCol(user[md.User_uid].ans[i] == 1 ? ans1[i].length / ans0.length : ans2[i].length / ans0.length) }}
                                                            onClick={() => { md.msg != '' && ClickMsg(md.uid, md.User_uid) }}>
                                                            <span className={md.msg == '' ? 'text-black-50' : ''}>
                                                                {md.msg == '' ? '지워진 댓글' : md.msg}
                                                            </span>
                                                        </div>
                                                        <div className='flex-fill'>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className='flex-fill'>
                                                </div>

                                            </div>
                                        )
                                    })}
                                    <div>
                                        <button className='btnt bn-light border rounded-pill px-4 py-2 my-3' style={{ width: '200px' }}
                                            onClick={() => {
                                                msgIdx.current = i;
                                                msgModalSet(true);
                                            }}>
                                            <i class="fi-rr-comment-medical va-m"></i> 댓글 쓰기 </button>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )}

            {(result || (!done && join)) && (
                <>
                    <div className='m-4'>
                        <div>
                            <img className='' src={ImgLogo} style={{ height: '100px' }}></img>
                        </div>
                        <div>
                            <img className='' src={ImgTitle} style={{ height: '50px' }}></img>
                        </div>
                    </div>


                    <div className='my-5 d-flex flex-column gap-2 justify-content-center align-items-center'>
                        <button className='btn btn-primary rounded-pill p-3 px-4 text-white' style={{ width: '300px' }} onClick={() => {
                            showAppDownloadModalSet(true);
                        }}>
                            <i class="fi-sr-plus va-m"></i> 나도 만들기
                        </button>
                        <button className='btn btn-primary rounded-pill p-3 px-4 text-white' style={{ width: '300px' }} onClick={() => { navigate('/') }}>
                            <i class="fi-sr-search va-m"></i> 질문 찾아보기
                        </button>
                    </div>

                    <div className='my-3'>
                        <Adsense type={'ia'} />
                    </div>
                </>
            )}


            <Offcanvas show={opModal} onHide={() => { opModalSet(false); }} placement='bottom' style={{ height: '140px' }}>
                <Offcanvas.Body >
                    <div className='d-flex flex-column gap-2 width-sm margin-auto'>
                        {game.player != 2 && (
                            <button className='btn btn-outline-dark' onClick={() => { CloseGame() }}> <i class="fi-sr-stop-circle va-m"></i> 지금 결과 보기</button>
                        )}
                        <button className='btn btn-outline-danger' onClick={() => { DelGame() }}> <i class="fi-sr-trash va-m"></i> 게임 삭제</button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas show={msgopModal} onHide={() => { msgopModalSet(false); }} placement='bottom' style={{ height: '90px' }}>
                <Offcanvas.Body >
                    <div className='d-flex flex-column gap-2 width-sm margin-auto'>
                        <button className='btn btn-outline-danger' onClick={() => { DelMsg() }}> <i class="fi-sr-trash va-m"></i> 댓글 삭제</button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>


            <ModalMsgInput show={msgModal} handleClose={() => { msgModalSet(false) }} gid={game.uid} idx={msgIdx.current} user={uuid} />

            <ModalCopyGame show={copyModal} handleClose={() => { copyModalSet(false) }} game={game} maker={nick} user={uuid} qz={game.qz} />

            <ShowFullImg show={showFimg} onHide={() => showFimgSet(false)} />

            <AppDownloadModal show={showAppDownloadModal} onHide={() => showAppDownloadModalSet(false)} />



            <Modal
                show={noti}
                onHide={() => { notiSet(false) }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        알림을 허용 해 주세요.
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        친구가 게임을 끝내고 결과가 나오면 알려 드릴게요.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {

                        notiSet(false);

                        if (Notification.permission !== 'denied') {
                            NotiReq(Static.SvrAddr);
                        }
                    }}>
                        확인 <i class="fi-rr-check-circle va-m"></i>
                    </Button>
                </Modal.Footer>
            </Modal>

            <Toaster />
        </div >


    )

}



export default Game;
